import stellaImg from "../assets/stella-designs-360-design-studio-website.webp";

import completeImg from "../assets/complete-energy-group-solar-solutions-website.webp";
export const projects = [
{
  id: 1,
  title: "Complete Energy Group (Australia) ",
  subtitle: "Full-Scale Solar Solutions Website for Australian Market",
  description: "Developed a professional, conversion-focused website for Complete Energy Group, featuring solar products, battery options, EV solutions, and lead-generating quote forms—all optimized for performance and user experience.",
  image: completeImg,
  category: "Freelancing Projects",
  tags: ["React", "SEO", "Responsive"],
  url: "#"
},
{
  id: 2,
  title: "Stella Designs (Mumbai, India)",
  subtitle: "Creative Studio Website for Environmental & Experiential Graphics",
  description: "Designed a dynamic and modern website for Stella Designs, a 360° design studio specializing in wall graphics, signage, and placemaking solutions. The site features smooth navigation, clear service presentation, and bold visual storytelling.",
  image: stellaImg,
  category: "Freelancing Projects",
  tags: ["Custom", "website", "Creative"],
  url: "#"
}
 
];
